import React, { useState } from "react";
// Components
import { TableBody, TableHead } from "./components";
// Hooks
import useActions from "hooks/useActions";
// Store Utils
import { markerStylesSortingAction } from "store/filters";
import { useDispatch } from "react-redux";
// Utils
import exportDataToCsv from "utils/exportDataToCsv";
import getAllRowsData from "utils/getAllRowsData";
// Exteranl Tools
import { snakeCase } from "change-case";
// Styling
import "./Communities.scss";
// types
import { TableProps } from "./types";
import apiLibrary from "services/api";
import { Toasts } from "view/components/Toasts";
import { filterKeys } from "Components/Users/Table";
import { useSelector } from "react-redux";
import { RootState } from "store";
import { filtersInitialState } from "store/filters/initialState";
import { useParams } from "react-router-dom";
import usePermissions from "hooks/usePermissions";

export const KEYS_TO_BE_REMOVED = ["id","select"];
const generatingDirectoryActions = (columns: any, rowsData: any) => {
  const dispatch = useDispatch();
  const { communities } = usePermissions();
  const { communityId } = useParams();
  const fileDownload = async () => {
    if (rowsData.length === 0) {
      Toasts.error("Please select at least one markerStyles from the table");
      return;
    }
    try {
      const res = await apiLibrary.file.fileDownload(
        "markerStyles",
        columns,
        rowsData.map((item: any) => {
          return item.name.id;
        })
      );

      // Convert the response to a Blob
      const blob = new Blob([res], { type: "application/octet-stream" });

      // Create a link element
      const link = document.createElement("a");

      // Set the href attribute to a URL created from the Blob
      link.href = window.URL.createObjectURL(blob);

      // Set the download attribute to specify the file name
      link.download = `markerStyles_${new Date().toISOString()}.csv`;

      // Append the link to the body
      document.body.appendChild(link);

      // Programmatically click the link to trigger the download
      link.click();

      // Remove the link from the DOM
      document.body.removeChild(link);

      Toasts.success("Download complete");
    } catch (error: any) {
      const errorMsg = error?.response?.data?.message ?? error?.message;
      Toasts.error(errorMsg);
    }
  };

  return [
    {
      label: "Export Details",
      onClick: () => fileDownload(),
      divider: false,
      isVisible: true,
    },
  ];
};

export const Table: React.FC<TableProps> = ({
  table,
  columnOrder,
  columns,
  columnVisibility,
  flexRender,
  setSorting,
  sorting,
}) => {
  const dispatch = useDispatch();
  const { markerStylesActions } = useActions();
  const { markerStylesFilter } = useSelector<RootState, filtersInitialState>(
    (state) => state.Filters
  );
  const DirectoryActions = () => {
    const filteredKeys = filterKeys(columnVisibility, columnOrder);
    return generatingDirectoryActions(
      filteredKeys,
      getAllRowsData(table, columnOrder, columnVisibility, columns)
    );
  };

  const getMarkerStylesActions = (data: any) => {
    const { id, name, group, community, markerStyleId, styleImage } = data;

    const modalData = {
      status: markerStylesFilter.status,
      id,
      name,
      community,
      group,
      markerStyleId,
      styleImage,
      path: "directory", 
    };

    return markerStylesActions(modalData);
  };

  const toggleSorting = (columnId: string) => {
    setSorting((currentSorting: any) => {
      const existingSort = currentSorting.find(
        (sort: any) => sort.columnId === columnId
      );
      const columnsId = snakeCase(columnId);
      if (!existingSort) {
        if (columnId === "alternativeNames") {
          dispatch(markerStylesSortingAction("alternative_name", "asc"));
        } else {
          dispatch(markerStylesSortingAction(columnsId, "asc"));
        }
        return [{ columnId, type: "asc" }];
      } else if (existingSort.type === "asc") {
        if (columnId === "alternativeNames") {
          dispatch(markerStylesSortingAction("alternative_name", "desc"));
        } else {
          dispatch(markerStylesSortingAction(columnsId, "desc"));
        }
        return [{ columnId, type: "desc" }];
      } else {
        dispatch(markerStylesSortingAction("", ""));

        return [];
      }
    });
  };
  const [hoveredHeader, setHoveredHeader] = useState<any>([]);
  const handleClickOnTableColumnHeading = (header: any, id: any) => {
    if (id === 1) {
      setHoveredHeader("");
      header.column.getCanSort() && toggleSorting(header.column.id);
      // setHoveredHeader(null);
    } else {
      setHoveredHeader(header.id);
    }
    // if(header.column)
    // header.column.getCanSort() && toggleSorting(header.column.id);
    // setHoveredHeader(null);
  };
  return (
    <div className="w-full overflow-hidden max-h-[80vh] overflow-x-auto overflow-y-auto">
      <table className="w-full">
        <TableHead
          table={table}
          sorting={sorting}
          flexRender={flexRender}
          DirectoryActions={DirectoryActions()}
          handleClickOnColumnHead={handleClickOnTableColumnHeading}
          setHoveredHeader={setHoveredHeader}
          hoveredHeader={hoveredHeader}
        />
        <TableBody
          flexRender={flexRender}
          table={table}
          columnVisibility={columnVisibility}
          getMarkerStylesActions={getMarkerStylesActions}
        />
      </table>
    </div>
  );
};
